import { render, staticRenderFns } from "./Flipbook.vue?vue&type=template&id=36f91f22"
import script from "./Flipbook.vue?vue&type=script&lang=js"
export * from "./Flipbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports